import script from "./TvRow.vue?vue&type=script&setup=true&lang=js"
export * from "./TvRow.vue?vue&type=script&setup=true&lang=js"

import "./TvRow.vue?vue&type=style&index=0&id=50e6379c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50e6379c"]])

export default __exports__